export const MESSAGE_KEY = 'ONBOARDING_TOURS';
export const STEP_PROGRESS_KEY = 'ONBOARDING_TOURS_STEP_PROGRESS';
export const MESSAGE_ACTIONS = {
  CLOSE: 'close',
  TOUR_COMPLETED: 'tourCompleted'
};